export const removePrecision = (value: number | string): string =>
    typeof value === "number" ? Math.trunc(value).toString() : value;
